import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

export default function ColumnsLayoutHorizontal(props) {
  const { content } = props;

  return (
    <Container>
      <WidthWrapper>
        {content.map((item, index) => (
          <Column key={index}>
            {item.image && (
              <Image
                src={item.image.src}
                alt={item.image.description || ""}
                title={item.image.title || ""}
                loading="lazy"
                width="200"
                height="200"
                srcSet={item.image.srcSet && item.image.srcSet}
                sizes={item.image.sizes && item.image.sizes}
              />
            )}
            <div>
              <Heading>{item.heading}</Heading>
              <Text key={item.text}>{item.text}</Text>
            </div>
          </Column>
        ))}
      </WidthWrapper>
    </Container>
  );
}

const Container = styled.div`
  background-color: #ffff;
`;

const WidthWrapper = styled.div`
  max-width: 1400px;
  display: flex;
  justify-content: center;
  padding: 30px 30px;
  margin: 0 auto;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  padding: 30px;
  display: flex;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Heading = styled.h2`
  color: #393a3c;
  font-size: 24px;
  font-weight: 400;

  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const Image = styled.img`
  max-width: 100%;
  padding: 20px;
`;

const Text = styled.p`
  color: #777;
  margin: 4px 0;

  @media (max-width: 1000px) {
    text-align: center;
  }
`;

ColumnsLayoutHorizontal.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      subheading: PropTypes.string.isRequired,
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        description: PropTypes.string,
        title: PropTypes.string,
        srcSet: PropTypes.string,
        sizes: PropTypes.string,
      }),
      text: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};
